import { Component } from '@angular/core';
import { ClipboardComponent } from '../clipboard.component';

@Component({
    selector: 'lib-clipboard-card-scroll',
    templateUrl: './clipboard-card-scroll.component.html',
    styleUrl: './clipboard-card-scroll.component.scss'
})
export class ClipboardCardScrollComponent extends ClipboardComponent {

}
